import Component from '@glimmer/component';

export default class ContentSkeletonComponent extends Component {
  get itemCount() {
    return this.args.itemCount || 3;
  }

  get showImages() {
    return this.args.showImages !== false;
  }

  get compact() {
    return this.args.compact || false;
  }

  get items() {
    return Array.from({ length: this.itemCount }, (_, i) => ({ id: i }));
  }

  <template>
    <div class="content-skeleton {{if this.compact 'compact'}}" ...attributes>
      {{#each this.items as |item|}}
        <div class="content-skeleton__item">
          {{#if this.showImages}}
            <div class="content-skeleton__image"></div>
          {{/if}}
          
          <div class="content-skeleton__content">
            <div class="content-skeleton__title"></div>
            <div class="content-skeleton__description"></div>
            <div class="content-skeleton__meta">
              <div class="content-skeleton__meta-item"></div>
              <div class="content-skeleton__meta-item"></div>
            </div>
          </div>
        </div>
      {{/each}}
    </div>

    <style>
      .content-skeleton {
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
      }

      .content-skeleton.compact {
        gap: 1rem;
      }

      .content-skeleton__item {
        display: flex;
        gap: 1rem;
        padding: 1rem;
        border: 1px solid #e5e7eb;
        border-radius: 8px;
        background: white;
      }

      .content-skeleton.compact .content-skeleton__item {
        padding: 0.75rem;
        gap: 0.75rem;
      }

      .content-skeleton__image {
        flex-shrink: 0;
        width: 120px;
        height: 80px;
        background: #f3f4f6;
        border-radius: 6px;
        animation: skeleton-pulse 1.5s ease-in-out infinite alternate;
      }

      .content-skeleton.compact .content-skeleton__image {
        width: 80px;
        height: 60px;
      }

      .content-skeleton__content {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 0.75rem;
      }

      .content-skeleton__title {
        height: 20px;
        background: #f3f4f6;
        border-radius: 4px;
        width: 80%;
        animation: skeleton-pulse 1.5s ease-in-out infinite alternate;
        animation-delay: 0.1s;
      }

      .content-skeleton__description {
        height: 16px;
        background: #f3f4f6;
        border-radius: 4px;
        width: 100%;
        animation: skeleton-pulse 1.5s ease-in-out infinite alternate;
        animation-delay: 0.2s;
      }

      .content-skeleton.compact .content-skeleton__description {
        height: 14px;
      }

      .content-skeleton__meta {
        display: flex;
        gap: 1rem;
        margin-top: auto;
      }

      .content-skeleton__meta-item {
        height: 14px;
        background: #f3f4f6;
        border-radius: 4px;
        width: 60px;
        animation: skeleton-pulse 1.5s ease-in-out infinite alternate;
        animation-delay: 0.3s;
      }

      .content-skeleton__meta-item:nth-child(2) {
        width: 80px;
        animation-delay: 0.4s;
      }

      @keyframes skeleton-pulse {
        0% {
          background: #f3f4f6;
        }
        100% {
          background: #e5e7eb;
        }
      }

      @media (max-width: 640px) {
        .content-skeleton__item {
          flex-direction: column;
        }

        .content-skeleton__image {
          width: 100%;
          height: 160px;
        }

        .content-skeleton.compact .content-skeleton__image {
          height: 120px;
        }
      }
    </style>
  </template>
}
